import { feedApi } from '../features/feed/service/feed.api';
import { attributesApi } from '../features/attributes/service/attributes';
import { botApi } from '../features/bot/service/bot';
import { productsApi } from '../features/products/service/products';
import { shopsApi } from '../features/shops/service/shops';
import { productsCategoriesApi } from '../features/categories/service/categories';
import { legalEntityApi } from '../../user/services/legalEntity';
import { promocodeApi } from '../features/promocodes/service/promocode.api';
import { ordersApi } from '../../crm/features/orders/service/orders';
import { bannersApi } from '../features/banners/service/banners';
import { aiApi } from '../features/ai-assistant/service/ai';
import { promocodeReducer } from '../features/promocodes/store/promocode.slice';
import { attributesReducer } from '../features/attributes/store/attributesSlice';
import { categoryReducer } from '../features/categories/store/categorySlice';
import { shopReducer } from '../features/shops/store/shopSlice';
import { commonAiApi } from '../../ai/services/ai';
import { aiReducer } from '../features/ai-assistant/store/aiSlice';
import { suggestionsReducer } from '../features/ai-assistant/store/suggestionsSlice';
import { paymentSystemReducer } from '../features/payments/store/paymentSystem.slice';
import { paymentSettingsApi } from '../features/payments/service/paymentSettings.api';
import { aiImageReducer } from '../../ai/store/aiImage.slice';

export const shopApi = [
    feedApi.middleware,
    attributesApi.middleware,
    botApi.middleware,
    productsApi.middleware,
    shopsApi.middleware,
    productsCategoriesApi.middleware,
    legalEntityApi.middleware,
    promocodeApi.middleware,
    ordersApi.middleware,
    bannersApi.middleware,
    paymentSettingsApi.middleware,
    aiApi.middleware,
    commonAiApi.middleware,
];

export const shopReducers = {
    [feedApi.reducerPath]: feedApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [shopsApi.reducerPath]: shopsApi.reducer,
    [productsCategoriesApi.reducerPath]: productsCategoriesApi.reducer,
    [legalEntityApi.reducerPath]: legalEntityApi.reducer,
    [promocodeApi.reducerPath]: promocodeApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [bannersApi.reducerPath]: bannersApi.reducer,
    [paymentSettingsApi.reducerPath]: paymentSettingsApi.reducer,
    [aiApi.reducerPath]: aiApi.reducer,
    [commonAiApi.reducerPath]: commonAiApi.reducer,
    [botApi.reducerPath]: botApi.reducer,
    [attributesApi.reducerPath]: attributesApi.reducer,

    aiProfile: aiReducer,
    suggestions: suggestionsReducer,
    category: categoryReducer,
    shop: shopReducer,
    promocodesSelector: promocodeReducer,
    attributesState: attributesReducer,
    paymentSystemSelector: paymentSystemReducer,
    aiImageSelector: aiImageReducer,
};
